var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8867 4.10938L15.0625 7.83594H14.6172C14.5312 7.17969 14.4141 6.71094 14.2656 6.42969C14.0234 5.97656 13.6992 5.64453 13.293 5.43359C12.8945 5.21484 12.3672 5.10547 11.7109 5.10547H9.47266V17.2461C9.47266 18.2227 9.57812 18.832 9.78906 19.0742C10.0859 19.4023 10.543 19.5664 11.1602 19.5664H11.7109V20H4.97266V19.5664H5.53516C6.20703 19.5664 6.68359 19.3633 6.96484 18.957C7.13672 18.707 7.22266 18.1367 7.22266 17.2461V5.10547H5.3125C4.57031 5.10547 4.04297 5.16016 3.73047 5.26953C3.32422 5.41797 2.97656 5.70312 2.6875 6.125C2.39844 6.54688 2.22656 7.11719 2.17188 7.83594H1.72656L1.91406 4.10938H14.8867Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19H22V20H13V19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextLine);
export default __webpack_public_path__ + "static/media/text-line.cd0494b4b7218201d9350feda2fbc478.svg";
export { ForwardRef as ReactComponent };